module.exports = __webpack_public_path__ + "img/kp.b3ff8d4e.svg";